/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

const ConversationsCtrl = function () {
  this.activeConversation = null;
  this.conversationSelect = id => (this.activeConversationId = id);
};

ConversationsCtrl.$inject = deps;

module.exports = ConversationsCtrl;
